<div class="error-container">
    <img class="error-image" src="/assets/images/info.png" />
    <div class="error-title">{{title}}</div>
    <div class="error-message">{{message}}</div>
    <button class="btn btn-default btn-ok" (click)="close()">Ok</button>
</div>
